<template>
  <div>
    <div class="col-12">
      <div class="row mb-3 ml-1 mt-2">
        <div class="item">
          <header>
            <h2>{{ $t('reports.cardPercentageOfNoReminder') }}</h2>
          </header>
          <div class="description">
            <span v-if="!loading">{{percentageOfNoReminder}}%</span>
            <b-spinner
              v-else
              variant="primary"
              type="grow"
              :label="`${this.$t('reports.loadingLabel')}...`"
            ></b-spinner>
          </div>
        </div>

        <div class="item">
          <header>
            <h2>{{ $t('reports.cardPercentageWithReminder') }}</h2>
          </header>
          <div class="description">
            <span v-if="!loading">{{percentageWithReminder}}%</span>
            <b-spinner
              v-else
              variant="primary"
              type="grow"
              :label="`${this.$t('reports.loadingLabel')}...`"
            ></b-spinner>
          </div>
        </div>
      </div>

      <div class="align-header">
        <label>{{ $t('reports.reportImpactReminder') }}</label>
      </div>

      <highcharts
        v-if="!loading"
        class="mt-4"
        :options="chartOptions"
      ></highcharts>
      <div v-else class="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>

      <div class="mt-4 over-flow">
        <b-table :items="items" :fields="fields" :busy="loading">
          <template #cell(ConversionTax)="row">
            {{ row.item.ConversionTax }}%
          </template>
          <template #cell(answerPerReminder)="row">
            {{ row.item.answerPerReminder }}%
          </template>
        </b-table>
      </div>
      <div v-if="loading" class="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../../../services/api';

export default {
  data: () => ({
    chartOptions: {
      type: 'column',
      title: '',
      xAxis: [
        {
          categories: [],
          crosshair: true,
        },
      ],
      yAxis: [
        {
          // Primary yAxis
          labels: {
            format: '{value}',
          },
          title: {
            text: 'Quantidade de convites',
          },
        },
        {
          // Secondary yAxis
          title: {
            text: 'Percentual de conversão',
          },
          labels: {
            format: '{value}',
          },
          max: 100,
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
      },
      legend: {
        floating: false,
        backgroundColor: 'rgba(255,255,255,0.25)',
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
          },
        },
      },
      series: [
        {
          name: 'Convites respondidos',
          type: 'column',
          yAxis: 0,
          data: [],
          tooltip: {
            valueSuffix: '',
          },
        },
        {
          name: 'Convites nao respondidos',
          type: 'column',
          yAxis: 0,
          data: [],
          tooltip: {
            valueSuffix: ' ',
          },
        },
        {
          name: '%',
          type: 'spline',
          yAxis: 1,
          data: [],
          tooltip: {
            valueSuffix: '',
          },
        },
      ],
    },
    loading: false,
    userAuth: null,
    reminder: 'Lembrete',
    itensGraph: null,
    items: [],
    fields: [
      { key: 'position', label: 'Lembretes', class: 'text-center' },
      {
        key: 'AnswersMade',
        label: 'Respostas realizadas',
        class: 'text-center',
      },
      {
        key: 'DispatchersMade',
        label: 'Disparos realizados',
        class: 'text-center',
      },
      {
        key: 'ConversionTax',
        label: 'Taxa de conversão por lembrete',
        class: 'text-center',
      },
      {
        key: 'answerPerReminder',
        label: '% de respostas por lembrete',
        class: 'text-center',
      },
      {
        key: 'consuptionPerDispatcher',
        label: 'Total de consumo por disparo',
        class: 'text-center',
      },
    ],
    percentageOfNoReminder: 0,
    percentageWithReminder: 0
  }),

  computed: {
    ...mapState('charts', ['invitesEvolution']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.prepareChart();
    },
    myActionId: function watchMyActionId() {
      this.prepareChart();
    },
    myActionsIds: function watchMyActionsIds() {
      this.prepareChart();
    },
    myIh1: function watchMyIh1() {
      this.prepareChart();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.prepareChart();
    },
    myIh2: function watchMyIh2() {
      this.prepareChart();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.prepareChart();
    },
    calendarDates: function watchDates() {
      this.prepareChart();
    },
    myMetric: function watchMyMetric() {
      this.prepareChart();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.prepareChart();
    },
    'indicatorData.period': function watchIndicatorPeriod() {
      this.prepareChart();
    },
    '$i18n.locale': function watchLocale() {
      this.updateTranslate();
    },
  },

  methods: {
    async prepareChart() {
      this.loading = true;
      const response = await api.get('/reports/reminder-analysis', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId:
            this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1:
            this.myHierarchies1.length === 0
              ? null
              : this.myHierarchies1.join(','),
          ih2:
            this.myHierarchies2.length === 0
              ? null
              : this.myHierarchies2.join(','),
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      const categories = [];

      this.itensGraph = response.data;

      this.reminder = this.$t('reports.reminderName');

      for (let i = 0; i < response.data.totalItems; i += 1) {
        categories.push(`${i}-${this.reminder}`);
      }

      this.chartOptions.xAxis = { categories };

      // // Convites respondidos
      this.chartOptions.series[0].data = response.data.result.answered;

      // // Convites não respondidos
      this.chartOptions.series[1].data = response.data.result.notAnswered;

      // // Valor da linha
      this.chartOptions.series[2].data = response.data.result.percentage;

      this.items = response.data.tableData;

      this.percentageOfNoReminder = response.data.answersWithoutReminders;
      this.percentageWithReminder = response.data.answersWithReminders;

      this.loading = false;
    },

    updateTranslate() {
      this.chartOptions.yAxis[0].title.text = this.$t(
        'reports.quantityInvites',
      );
      this.chartOptions.yAxis[1].title.text = this.$t(
        'reports.conversionPercentage',
      );
      this.chartOptions.series[0].name = this.$t('reports.answeredInvites');
      this.chartOptions.series[1].name = this.$t(
        'reports.unansweredInvitations',
      );

      this.reminder = this.$t('reports.reminderName');
      const categories = [];

      for (let i = 0; i < this.itensGraph.totalItems; i += 1) {
        categories.push(`${i}-${this.reminder}`);
      }

      this.chartOptions.xAxis = { categories };
    },
  },

  async mounted() {
    await this.prepareChart();
    this.updateTranslate();
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: column;
  padding: 5px 8px;
  margin-right: 10px;
  min-height: 79px;
  max-height: 79px;
  min-width: 115px;
  max-width: 115px;
  -webkit-box-shadow: 0px 0px 9px -6px #000000;
  box-shadow: 0px 0px 9px -6px #000000;
  transition: 0.3s;
  text-align: center;
  color: black;

  &:hover {
    -webkit-box-shadow: 0px 0px 12px -6px #000000;
    box-shadow: 0px 0px 12px -6px #000000;
  }

  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;

    h2 {
      font-size: 11px;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    color: black;

    span {
      font-size: 22px;
      font-weight: lighter;

      & + span {
        margin-top: -3px;
        font-size: 12px;
      }
    }
  }

  &:last-of-type {
    margin-right: 30px;
  }
}

.align-header {
  display: flex;
  justify-content: space-between;
}

.over-flow {
  max-height: 400px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/reminder-impact/index.vue